import * as React from 'react';

import * as styles from './styles.css';

export const SpecificWrapper: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
